import { Component } from "react";
import "../EarnRewards/EarnRewards.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HelpdeskApiCall from 'HelpdeskApiCall';
import config from "config";
import SuccessModal from "HELPDESK/CommonResources/SuccessModal/SuccessModal";
import Spinner from "HELPDESK/CommonResources/SpinnerLoader/Spinner";
import phoneImg from "HELPDESK/CommonResources/images/new phone.png";
import mailImg from "HELPDESK/CommonResources/images/new new mail.png";
import remarkLogo from "HELPDESK/CommonResources/images/comment-fill.png"

export default class EarnRewards extends Component {
    constructor(props) {
        super(props);

        this.state = {
            steps: {
                "1️⃣ Add an Institute": "Add an Institute where you wish to introduce and educate faculties about the power of vmedulife software’s modules.",
                "2️⃣ Verification Process": "Our team will verify the provided details within 48 hours to ensure authenticity and quality engagement.",
                "3️⃣ Account Activation": "Once approved, a vmedulife account will be created for the institute, and login credentials will be sent to the registered email.",
                "4️⃣ Educate & Inspire": "Provide a meaningful overview of all vmedulife modules to help institutions unlock their full potential.",
                "5️⃣ Earn Recognition & Rewards": "Upon successful onboarding and confirmation from the institute, you become eligible for exciting rewards.",
                "6️⃣ Act Swiftly": "⏳ If the added institute does not move forward within 30 days, the opportunity opens up for others."
            },
            addInstituteModal: false,
            instituteName: "",
            instEmpty: false,
            firstName: '',
            firstEmpty: false,
            lastName: "",
            lastEmpty: false,
            designation: "",
            desigEmpty: false,
            contact: "",
            contactEmpty: false,
            email: "",
            emailEmpty: false,
            successType: "",
            successModal: false,
            successMessage: "",
            mobileExistMessage: "",
            emailExistMessage: "",
            Referrals: {},
            ReferralsFetching: false,
            editId: "",
            editModal: false,
            referralUID: "",
        }
    }

    componentDidMount() {
        this.apiCallToGetReferrals();

    }

    apiCallToGetReferrals = async () => {
        this.setState({
            ReferralsFetching: true,
        })

        let requestData = {
            "iid": config.institute_id,
            "faculty_id": config.faculty_id
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'HelpdeskGetReferral',
            requestData,
            '/api/helpDesk/helpDeskEarnRewards.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetReferrals()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                this.setState({
                    ReferralsFetching: false,
                    Referrals: Object.values(apiResult).length > 0 ? apiResult.referral_data : {}
                });
            } else {
                this.setState({
                    ReferralsFetching: false,
                    successModal: true,
                    successType: 'error',
                    successMessage: jsonResponse.APIResult.message
                });
            }
        }
    }

    clearModal = () => {
        this.setState({
            instituteName: "",
            instEmpty: false,
            firstName: '',
            firstEmpty: false,
            lastName: "",
            lastEmpty: false,
            designation: "",
            desigEmpty: false,
            contact: "",
            contactEmpty: false,
            email: "",
            emailEmpty: false,
            addInstituteModal: false,
            editModal: false,
            referralUID: "",
            emailExistMessage: "",
            mobileExistMessage: ""
        })
    }

    closeSuccessModal = () => {
        this.setState({
            successModal: false
        })
    }

    apiCallToUpdateReferral = async () => {

        let requestData = {
            "institute_name": this.state.instituteName,
            "user_first_name": this.state.firstName,
            "user_last_name": this.state.lastName,
            "designation": this.state.designation,
            "contact": this.state.contact,
            "email": this.state.email,
            "referred_by_iid": config.institute_id,
            "uid": this.state.referralUID
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'HelpdeskUpdateReferral',
            requestData,
            '/api/helpDesk/helpDeskEarnRewards.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToUpdateReferral()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                this.setState({
                    successModal: true,
                    successType: 'success',
                    successMessage: jsonResponse.APIResult.message,
                    instituteName: "",
                    firstName: '',
                    lastName: "",
                    designation: "",
                    contact: "",
                    email: "",
                    addInstituteModal: false,
                    editModal: false,
                    referralUID: ""
                }, () => this.apiCallToGetReferrals());
            } else {
                this.setState({
                    successModal: true,
                    successType: 'error',
                    successMessage: jsonResponse.message
                });
            }
        }

    }

    apiCallToAddReferral = async () => {

        let requestData = {
            "institute_name": this.state.instituteName,
            "user_first_name": this.state.firstName,
            "user_last_name": this.state.lastName,
            "designation": this.state.designation,
            "contact": this.state.contact,
            "email": this.state.email,
            "referred_by": config.faculty_id,
            "referred_by_iid": config.institute_id
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'HelpdeskAddReferral',
            requestData,
            '/api/helpDesk/helpDeskEarnRewards.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToAddReferral()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                this.setState({
                    successModal: true,
                    successType: 'success',
                    successMessage: jsonResponse.APIResult.message,
                    instituteName: "",
                    firstName: '',
                    lastName: "",
                    designation: "",
                    contact: "",
                    email: "",
                    addInstituteModal: false,
                    editModal: false
                }, () => this.apiCallToGetReferrals());
            } else {
                this.setState({
                    successModal: true,
                    successType: 'error',
                    successMessage: jsonResponse.APIResult.message
                });
            }
        }
    }

    apiCallToCheckMobileExist = async () => {
        let requestData = {
            "iid": config.institute_id,
            "contact": this.state.contact
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'HelpdeskGetReferralMobile',
            requestData,
            '/api/helpDesk/helpDeskEarnRewards.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToCheckMobileExist()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                this.setState({
                    mobileExistMessage: jsonResponse.APIResult.message,

                });
            }
        }

    }




    apiCallToCheckEmailExist = async () => {
        let requestData = {
            "iid": config.institute_id,
            "email": this.state.email
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'HelpdeskGetReferralEmail',
            requestData,
            '/api/helpDesk/helpDeskEarnRewards.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToCheckEmailExist()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                this.setState({
                    emailExistMessage: jsonResponse.APIResult.message,

                });
            }
        }

    }

    validateData = (key) => {


        let isValid = true;

        const { instituteName, firstName, lastName, designation, contact, email } = this.state;
        const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

        if (instituteName == "") {
            this.setState({
                instEmpty: true,
            })
            isValid = false;
        }

        if (firstName == "") {
            this.setState({
                firstEmpty: true,
            })
            isValid = false;
        }

        if (lastName == "") {
            this.setState({
                lastEmpty: true,
            })
            isValid = false;
        }

        if (designation == "") {
            this.setState({
                desigEmpty: true,
            })
            isValid = false;
        }

        if (contact == "" || contact.length !== 10) {
            this.setState({
                contactEmpty: true,
                mobileExistMessage: "Invalid mobile number"
            })
            isValid = false;
        }

        if (email == "" || !emailPattern.test(email)) {
            this.setState({
                emailEmpty: true,
                emailExistMessage: "Invalid email address"
            })
            isValid = false;
        }

        if (isValid) {

            if (key == "edit") {

                this.apiCallToUpdateReferral().then(() => this.setState({
                    instEmpty: false,
                    firstEmpty: false,
                    lastEmpty: false,
                    desigEmpty: false,
                    contactEmpty: false,
                    emailEmpty: false,
                }))
            }
            else {
                this.apiCallToAddReferral().then(() => this.setState({
                    instEmpty: false,
                    firstEmpty: false,
                    lastEmpty: false,
                    desigEmpty: false,
                    contactEmpty: false,
                    emailEmpty: false,
                }))
            }

        }
    }

    openEditModal = (referral) => {
        this.setState({
            editModal: true,
            instituteName: referral.institute_name,
            firstName: referral.user_first_name,
            lastName: referral.user_last_name,
            designation: referral.user_designation,
            contact: referral.user_contact,
            email: referral.user_email,
            referralUID: referral.unique_id
        })
    }

    AddInstituteModal = () => {
        return (
            <div className={this.state.addInstituteModal || this.state.editModal ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "70vw" }}>
                    <div className="modal-content">
                        <div className="modal-header" style={{ padding: "10px", backgroundColor: "#0465ac", color: "white" }}>
                            <p style={{ fontWeight: "bold" }}>{this.state.editModal ? "Update Institute" : "Add Institute"}</p>
                            <FontAwesomeIcon icon={['fas', 'times']} style={{ cursor: 'pointer' }} size="lg" onClick={() => this.clearModal()} />
                        </div>
                        <div className="modal-body">

                            <div className='mb-3 custom-input-container'>
                                <label className='fs-12' ><span style={{ fontSize: "14px" }}>Institute <span style={{ color: "red" }}>*</span></span></label>
                                <input
                                    style={{ fontSize: "14px" }}
                                    className={this.state.instEmpty ? 'border-danger' : ""}
                                    placeholder='Enter Institute Name'
                                    value={this.state.instituteName}
                                    onChange={(e) => this.setState({ instituteName: e.target.value })}
                                />
                            </div>

                            <div className="d-flex justify-content-between" style={{ gap: "20px" }}>
                                <div className='mb-3 custom-input-container' style={{ width: "100%" }}>
                                    <label className='fs-12' ><span style={{ fontSize: "14px" }}>First Name<span style={{ color: "red" }}> *</span></span></label>
                                    <input
                                        style={{ fontSize: "14px" }}
                                        className={this.state.firstEmpty ? 'border-danger' : ""}
                                        placeholder='Enter First Name'
                                        value={this.state.firstName}
                                        onChange={(e) => this.setState({ firstName: e.target.value })}
                                    />
                                </div>


                                <div className='mb-3 custom-input-container' style={{ width: "100%" }}>
                                    <label className='fs-12' ><span style={{ fontSize: "14px" }}>Last Name<span style={{ color: "red" }}> *</span></span></label>
                                    <input
                                        style={{ fontSize: "14px" }}
                                        className={this.state.lastEmpty ? 'border-danger' : ""}
                                        placeholder='Enter Last Name'
                                        value={this.state.lastName}
                                        onChange={(e) => this.setState({ lastName: e.target.value })}
                                    />
                                </div>

                                <div className='mb-3 custom-input-container' style={{ width: "100%" }}>
                                    <label className='fs-12' ><span style={{ fontSize: "14px" }}>Designation<span style={{ color: "red" }}> *</span></span></label>
                                    <input
                                        style={{ fontSize: "14px" }}
                                        className={this.state.desigEmpty ? 'border-danger' : ""}
                                        placeholder='Enter Designation'
                                        value={this.state.designation}
                                        onChange={(e) => this.setState({ designation: e.target.value })}
                                    />
                                </div>
                            </div>

                            <div className="d-flex justify-content-between" style={{ gap: "20px" }}>
                                <div className='mb-3 custom-input-container' style={{ width: "100%" }}>
                                    <label className='fs-12' ><span style={{ fontSize: "14px" }}>Contact Number<span style={{ color: "red" }}> *</span></span></label>
                                    <input
                                        type="number"
                                        style={{ fontSize: "14px" }}
                                        className={this.state.contactEmpty ? 'border-danger' : ""}
                                        placeholder='Enter Contact Number'
                                        value={this.state.contact}
                                        onChange={(e) => this.setState({ contact: e.target.value }, () => this.apiCallToCheckMobileExist())}
                                    />
                                    <span style={{ color: "red", fontSize: "12px" }}>{this.state.mobileExistMessage}</span>
                                </div>

                                <div className='mb-3 custom-input-container' style={{ width: "100%" }}>
                                    <label className='fs-12' ><span style={{ fontSize: "14px" }}>Email<span style={{ color: "red" }}> *</span></span></label>
                                    <input
                                        type="email"
                                        style={{ fontSize: "14px" }}
                                        className={this.state.emailEmpty ? 'border-danger' : ""}
                                        placeholder='Enter Email Id'
                                        value={this.state.email}
                                        onChange={(e) => this.setState({ email: e.target.value }, () => this.apiCallToCheckEmailExist())}
                                    />
                                    <span style={{ color: "red", fontSize: "12px" }}>{this.state.emailExistMessage}</span>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex justify-content-end mb-2 mr-2" style={{ gap: "20px" }}>
                            <button
                                className="btn btn-primary"
                                onClick={() => this.setState({
                                    instEmpty: false,
                                    firstEmpty: false,
                                    lastEmpty: false,
                                    desigEmpty: false,
                                    contactEmpty: false,
                                    emailEmpty: false
                                }, () => this.validateData(this.state.editModal ? "edit" : "add"))}
                            >
                                {this.state.editModal ? "Update Institute" : "Add Institute"}
                            </button>

                            <button
                                onClick={() => this.clearModal()}
                                className="btn btn-outline-primary bg-transparent border-primary text-primary">
                                cancel
                            </button>


                        </div>

                    </div>
                </div>
            </div>
        );
    }


    render() {

        return (
            <div className="earnrewardsComponent ml-3">

                <div className="stickyDiv">
                    <div className='heading ' >
                        <p>Educate Others and Earn Rewards!</p>
                    </div>

                    <div className="d-flex justify-content-between pr-4 pt-4">
                        <p style={{ color: "#747474", fontSize: "14px", fontWeight: "bold" }}>How To Earn Rewards?</p>

                        <div
                            className="addinst"
                            onClick={() => this.setState({ addInstituteModal: true })}
                        >
                            <FontAwesomeIcon icon={['fa', 'plus']} size="sm" style={{ marginTop: "2px" }} />
                            <p style={{ fontSize: "14px" }}>Add Institute</p>
                        </div>
                    </div>

                    <div>
                        <ul style={{ fontSize: "13px" }}>
                            <li style={{
                  
                                listStyleType: "none"
                            }}> <span style={{ fontWeight: 'bold',fontSize:'15px' }}> 🌟 Take the First Step Towards Transforming Education with vmedulife! 🌟</span></li>
                            {
                                Object.entries(this.state.steps).map(([key, value], i) => (
                                    <li key={i} style={{listStyleType: "none",marginLeft:'30px'}}>
                                       <span style={{ fontWeight: "bold" }}>{key}</span>  {" : "} <span>{value}</span> 
                                    </li>
                                ))
                            }

                            <li style={{ fontWeight: 'bold',listStyleType: "none" ,marginTop:'5px'}}> 🚀 Let’s make quality education seamless and digital – one institute at a time!</li>
                            <li style={{listStyleType: "none",marginBottom:'10px',marginLeft:'30px'}} >💡 Your initiative today can be a turning point for tomorrow’s academic excellence.</li>
                        </ul>

                    </div>
                </div>
                <div className="referralsDiv">
                    {
                        this.state.ReferralsFetching ?
                            <Spinner />
                            :
                            Object.values(this.state.Referrals).length > 0 ?
                                Object.values(this.state.Referrals).map((referral, i) =>
                                    <div className="referralBox" key={i}
                                        onMouseEnter={() => this.setState({ editId: referral.unique_id })}
                                        onMouseLeave={() => this.setState({ editId: "" })}>
                                        <div className="d-flex justify-content-between">
                                            <p className="institute">{referral.institute_name}</p>

                                            <div className="d-flex" style={{ gap: '25px' }}>
                                                {this.state.editId == referral.unique_id &&
                                                    <div className="d-flex" style={{ gap: "12px" }}>
                                                        <FontAwesomeIcon onClick={() => this.openEditModal(referral)} icon={['fas', 'pencil-alt']} style={{ cursor: 'pointer' }} size="md" />

                                                        {/* <FontAwesomeIcon icon={['fas', 'trash-alt']} style={{ cursor: 'pointer' }} size="md" /> */}

                                                    </div>
                                                }
                                                <button className={`btn ${referral.status == "Pending" ? "btn-warning" : referral.status == "Approved" ? "btn-success" : "btn-danger"} pt-0 pb-0`} style={{ borderRadius: "50px" }}>
                                                    {referral.status}
                                                </button>


                                            </div>


                                        </div>
                                        <div className="info">

                                            <div className="d-flex" style={{ gap: "10px", alignItems: "center" }}>

                                                <div className="logo">
                                                    {referral.user_first_name[0].toUpperCase()}{referral.user_last_name[0].toUpperCase()}
                                                </div>


                                                <p style={{ fontSize: "14px" }}>{referral.user_first_name.charAt(0).toUpperCase() + referral.user_first_name.slice(1)} {referral.user_last_name}</p>
                                                <p style={{ fontSize: "14px", color: "#878787" }}>{referral.user_designation}</p>
                                                <p className="dividers">|</p>
                                                <div className="d-flex" style={{ gap: "10px", alignItems: "center" }}>
                                                    <img src={phoneImg} style={{ width: "20px", height: "17px" }} />
                                                    <p style={{ fontSize: "14px" }}>{referral.user_contact}</p>
                                                </div>
                                                <p className="dividers">|</p>
                                                <div className="d-flex" style={{ gap: "10px", alignItems: "center" }}>
                                                    <img src={mailImg} style={{ width: "20px", height: "15px" }} />
                                                    <p style={{ fontSize: "14px" }} title={referral.user_email}>{referral.user_email.length > 25 ? referral.user_email.substring(0, 25) + "..." : referral.user_email}</p>
                                                </div>
                                                <p className="dividers">|</p>
                                                <div className="d-flex" style={{ gap: "10px", alignItems: "center" }}>
                                                    <img src={remarkLogo} style={{ width: "20px", height: "15px" }} />
                                                    <p style={{ fontSize: "14px" }} title={referral.remark}>{referral.remark.length > 25 ? referral.remark.substring(0, 25) + "..." : referral.remark}</p>
                                                </div>


                                            </div>

                                            <div className="expiryCount">
                                                <p style={{ fontSize: "14px", fontWeight: "bold" }}>Expiry Countdown : <span style={{ color: "#0079FF", fontSize: "18px" }}>{referral.expiry}</span> Days</p>
                                            </div>
                                        </div>
                                    </div>
                                )
                                :
                                <div style={{ backgroundColor: "white", fontWeight: "bold", alignItems: "center", height: "40vh", fontSize: "14px", padding: "20px" }}>
                                    Currently, no referred institutes have been added. Follow the instructions above to start earning rewards.</div>
                    }
                </div>



                {
                    this.AddInstituteModal()
                }

                {
                    this.state.successModal &&
                    <SuccessModal
                        successModal={this.state.successModal}
                        successModalType={this.state.successType}
                        successMessage={this.state.successMessage}
                        closeSuccessModal={this.closeSuccessModal}
                    />
                }
            </div>
        )
    }
}